module.exports = __webpack_public_path__ + "h5/img/noproduct.7aec7edd.png";